import { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle, X } from "lucide-react";
import { API } from "../lib/apiClient";
import { waTarget } from "../lib/wa";
import { fillTemplate } from "../lib/appt";

let cache = null;
export const loadTemplates = async (force = false) => {
  if (!cache || force) cache = (await axios.get(`${API}/wa-templates`)).data;
  return cache;
};
export const setTemplatesCache = (list) => { cache = list; };

export function WaTemplateButton({ appt, className = "mini-btn wa", label = "WhatsApp", testId }) {
  const [open, setOpen] = useState(false);
  const [list, setList] = useState(cache || []);
  const target = waTarget(appt.phone);
  useEffect(() => { if (open) loadTemplates().then(setList).catch(() => {}); }, [open]);
  if (!target) return null;
  const send = (text) => {
    window.open(`https://wa.me/${target}${text ? `?text=${encodeURIComponent(text)}` : ""}`, "_blank", "noopener");
    setOpen(false);
  };
  return (
    <>
      <button type="button" className={className} onClick={(e) => { e.stopPropagation(); setOpen(true); }} data-testid={testId || `appt-wa-${appt.id}`}><MessageCircle size={13} /> {label}</button>
      {open && (
        <div className="modal-backdrop wa-tpl-backdrop" onClick={(e) => { e.stopPropagation(); setOpen(false); }} data-testid="wa-template-picker">
          <div className="wa-tpl-sheet" onClick={(e) => e.stopPropagation()}>
            <div className="modal-head"><h2>WhatsApp mesajı seçin</h2><button className="icon-button" onClick={() => setOpen(false)} data-testid="wa-template-close"><X size={18} /></button></div>
            <ul>
              {list.map((t) => (
                <li key={t.id}><button type="button" onClick={() => send(fillTemplate(t.text, appt))} data-testid={`wa-template-${t.id}`}>
                  <strong>{t.name}</strong><span>{fillTemplate(t.text, appt)}</span>
                </button></li>
              ))}
              <li><button type="button" onClick={() => send("")} data-testid="wa-template-blank"><strong>Boş mesaj</strong><span>Sohbeti şablonsuz aç</span></button></li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
}
